import { First } from '../components/desktop/First'
import { DraggableWrapper } from '../components/Wrappers'

export const FirstLand = () => {
    return(
        <DraggableWrapper bg='white' width="100%" height='100%' flexDirection='column' justifyContent='center' overflow='hidden'>
            <First />
        </DraggableWrapper>
    )
}